import { AxiosError } from 'axios';
import {
  MutationFunction,
  useMutation,
  UseMutationResult,
  useQueryClient
} from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { Comment } from '@utils/types/comments/comments.ts';

type CreateCommentVariables = {
  session_id: string;
  document_id: string;
  text?: string;
  index_from?: string;
  index_to?: string;
};

export const useCreateComment = (): UseMutationResult<
  Comment,
  AxiosError<BaseError>,
  CreateCommentVariables,
  unknown
> => {
  const queryClient = useQueryClient();

  const createComment: MutationFunction<
    Comment,
    CreateCommentVariables
  > = async ({ session_id, document_id, text, index_from, index_to }) => {
    const response = await Axios.post<Comment>(
      POST_URL(session_id, document_id).createComment,
      {
        text,
        index_from,
        index_to
      }
    );
    return response.data;
  };

  return useMutation(createComment, {
    onSuccess: () => {
      queryClient.invalidateQueries(['comments']);
    }
  });
};
